<template>
  <form @submit.prevent="onSubmit">
    <p v-if="messageSuccess" class="mt-0 text-center text-success">
      <b>{{ messageSuccess ? messageSuccess : '' }}</b>
    </p>
    <p v-if="messageFailure" class="mt-0 text-center text-danger">
      <b>{{ messageFailure ? messageFailure : '' }}</b>
    </p>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text">Nom et Postnom</label>
        <label class="input-group-text"></label>
      </div>
      <input v-model="dataForm.nom"
             class="form-control"
             name="joueur_nom"
             placeholder="Entrez le nom du joueur"
             type="text">
      <input v-model="dataForm.postnom"
             class="form-control"
             name="joueur_postnom"
             placeholder="Entrez le postnom du joueur"
             type="text">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-append">
        <label class="input-group-text">Prénom</label>
      </div>
      <input v-model="dataForm.prenom"
             class="form-control"
             name="joueur_prenom"
             placeholder="Entrez le prenom du joueur"
             type="text">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-append">
        <label class="input-group-text">Poste</label>
      </div>
      <input v-model="dataForm.poste"
             class="form-control"
             name="joueur_poste"
             placeholder="Entrez le poste du joueur"
             type="text">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-append">
        <label class="input-group-text">Taille</label>
      </div>
      <input v-model="dataForm.taille"
             class="form-control"
             name="joueur_taille"
             placeholder="Entrez la taille du joueur"
             type="text">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-append">
        <label class="input-group-text">Poids</label>
      </div>
      <input v-model="dataForm.poids"
             class="form-control"
             name="joueur_poids"
             placeholder="Entrez le poids du joueur"
             type="text">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-append">
        <label class="input-group-text">Date de naissance</label>
      </div>
      <input v-model="dataForm.date_naissance"
             class="form-control"
             name="joueur_date_naissance"
             type="date">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-append">
        <label class="input-group-text">Dossard</label>
      </div>
      <input v-model="dataForm.dossard"
             class="form-control"
             name="joueur_dossard"
             placeholder="Entrez le numero du dossard du joueur"
             type="number">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-append">
        <label class="input-group-text">Photo passeport</label>
      </div>
      <input ref="fileToUpload"
             @change="handleFileToUpload"
             lang="fr"
             type="file"
             class="form-control"
             accept=".png, .jpeg, .jpg">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text">Nationalité</label>
      </div>
      <select v-model="dataForm.nationalite"
              class="custom-select"
              name="joueur_nationalite">
        <option :value="dataForm.nationalite">{{ dataForm.nationalite }}</option>
        <option value="">-------------------------------------</option>
        <option :key="'nationalite'+idx"
                :value="nationalite.value"
                v-for="(nationalite, idx) in getNationalites">{{ nationalite.nationalites }}</option>
      </select>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text">Equipe</label>
      </div>
      <select v-model="dataForm.equipe_id"
              class="custom-select"
              name="joueur_equipe">
        <option :value="joueur.championnat_id">
          {{ equipes ?
            (equipes.filter((equipe) => equipe.equipe_id === joueur.equipe_id)[0].nom) :
            'Choisissez une équipe...' }}
        </option>
        <option value="">-------------------------------------</option>
        <option :key="equipe.equipe_id.slice(5,15)"
                :value="equipe.equipe_id"
                v-for="equipe in equipes">
          {{ equipe.nom }}
        </option>
      </select>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text">Date début et fin du contrat</label>
        <label class="input-group-text"></label>
      </div>
      <input v-model="dataForm.date_debut_contrat"
             class="form-control"
             name="joueur_date_debut_contrat"
             type="date">
      <input v-model="dataForm.date_fin_contrat"
             class="form-control"
             name="joueur_date_fin_contrat"
             type="date">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-append">
        <label class="input-group-text">Commentaires</label>
      </div>
      <textarea v-model="dataForm.commentaires"
                class="form-control"
                name="joueur_commentaires"
                placeholder="Entrez vos commentaires sur le joueur">
      </textarea>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text">Telephones</label>
        <label class="input-group-text"></label>
      </div>
      <input v-model="dataForm.telephones"
             class="form-control"
             name="joueur_telephone_1"
             placeholder="Entrez le numéro prncipal du joueur"
             type="tel">
      <input v-model="dataForm.telephones"
             class="form-control"
             name="joueur_telephone_2"
             placeholder="Entrez le numéro secondaire du joueur"

             type="tel">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text">Email</label>
      </div>
      <input v-model="dataForm.email"
             class="form-control"
             name="joueur_email"
             placeholder="Entrez l'adresse email du joueur"
             type="email">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text">Surnom</label>
      </div>
      <input v-model="dataForm.surnom"
             class="form-control"
             name="joueur_surnom"
             placeholder="Entrez le sobriqué ou surnom du joueur"
             type="text">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text">Type des contrats</label>
      </div>
      <select v-model="dataForm.type_contrat"
              class="custom-select"
              name="joueur_type_contrat">
        <option :value="joueur.type_contrat">
          {{ joueur.type_contrat }}
        </option>
        <option value="">-------------------------------------</option>
        <option :key="'type_contrat'+idx"
                :value="type_contrat"
                v-for="(type_contrat, idx) in getTypesContratJoueurs">{{ type_contrat }}</option>
      </select>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="mr-3">Selectionné ? </div>
      <div class="form-check form-check-inline">
        <input class="form-check-input"
               type="radio"
               v-model="dataForm.selectionne"
               name="joueur_selectionne"
               value="oui">
        <label class="form-check-label rounded pl-2 pr-2">OUI</label>
      </div>
      <div class="form-check form-check-inline">
        <input class="form-check-input"
               type="radio"
               v-model="dataForm.selectionne"
               name="joueur_selectionne"
               value="non">
        <label class="form-check-label rounded pl-2 pr-2">NON</label>
      </div>
    </div>
    <div class="mt-4 mb-3 text-center">
      <button class="btn btn-sm btn-success" type="submit">SAUVEGARDER</button>
    </div>
  </form>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from 'vuex'

export default {
  name: "Update",
  props: {
    joueur: {
      type: Object
    }
  },
  data() {
    return {
      equipes: null,
      messageSuccess: '',
      messageFailure: '',
      dataForm: {
        nom: '',
        postnom: '',
        prenom: '',
        poste: '',
        taille: '',
        poids: '',
        date_naissance: '',
        dossard: '',
        photo_passeport: '',
        nationalite: '',
        equipe_id: '',
        date_debut_contrat: '',
        date_fin_contrat: '',
        commentaires: '',
        telephones: '',
        email: '',
        surnom: '',
        type_contrat: '',
        selectionne: 'oui',
        table: 'joueurs',
        table_id: this.joueur.joueur_id,
      },
      file: '',
    }
  },
  watch: {
    messageSuccess : function () {
      let vm = this;
      setTimeout( () => vm.messageSuccess = "", 5000)
      location.reload(false)
    },
    messageFailure : function () {
      let vm = this;
      setTimeout( () => vm.messageFailure = "", 5000)
    }
  },
  components: {},
  methods: {
    ...mapMutations([]),
    ...mapActions([
      'axiosGetAllData',
      'axiosPutData',
      'axiosPostFileData',
    ]),
    handleFileToUpload(){
      this.file = this.$refs.fileToUpload.files[0];
    },
    uploadFile () {
      let formData = new FormData()
      let fileName = ''
      if(this.dataForm.nom && this.dataForm.postnom && this.dataForm.prenom){
        fileName = this.dataForm.prenom.toLowerCase() + '_' +
            this.dataForm.postnom.toLowerCase() + '_' +
            this.dataForm.nom.toLowerCase() + '_' + Math.floor(Math.random() * 1000000) + 1;
      }
      formData.append('fileToUpload', this.file)
      formData.append('fileName', fileName)
      formData.append('to', "joueurs")
      this.axiosPostFileData(formData)
        .then(data => {
          this.dataForm.photo_passeport = data[2];
          this.resetDefaultValues()
          if(!this.dataForm.photo_passeport)
            this.dataForm.photo_passeport = this.joueur.photo_passeport
          this.axiosPutData(this.dataForm)
            .then((data) => {
              if(data.status === 204)
                this.messageSuccess = "Joueur modifié avec succès !"
              else
                this.messageFailure = "Une erreur est survenue lors de la modification du joueur !"
            })
            .catch((error) => {
              this.messageFailure = "Une erreur est survenue lors de la modification du joueur !"
            })
        })
        .catch(data => {})
    },
    onSubmit() {
      this.uploadFile()
    },
    resetDefaultValues() {
      if(this.dataForm.nom === '')
        this.dataForm.nom = this.joueur.nom
      if(this.dataForm.postnom === '')
        this.dataForm.postnom = this.joueur.postnom
      if(this.dataForm.prenom === '')
        this.dataForm.prenom = this.joueur.prenom
      if(this.dataForm.poste === '')
        this.dataForm.poste = this.joueur.poste
      if(this.dataForm.taille === '')
        this.dataForm.taille = this.joueur.taille
      if(this.dataForm.poids === '')
        this.dataForm.poids = this.joueur.poids
      if(this.dataForm.date_naissance === '')
        this.dataForm.date_naissance = this.joueur.date_naissance
      if(this.dataForm.dossard === '')
        this.dataForm.dossard = this.joueur.dossard
      if(this.dataForm.photo_passeport === '')
        this.dataForm.photo_passeport = this.joueur.photo_passeport
      if(this.dataForm.nationalite === '')
        this.dataForm.nationalite = this.joueur.nationalite
      if(this.dataForm.equipe_id === '')
        this.dataForm.equipe_id = this.joueur.equipe_id
      if(this.dataForm.date_debut_contrat === '')
        this.dataForm.date_debut_contrat = this.joueur.date_debut_contrat
      if(this.dataForm.date_fin_contrat === '')
        this.dataForm.date_fin_contrat = this.joueur.date_fin_contrat
      if(this.dataForm.commentaires === '')
        this.dataForm.commentaires = this.joueur.commentaires
      if(this.dataForm.telephones === '')
        this.dataForm.telephones = this.joueur.telephones
      if(this.dataForm.email === '')
        this.dataForm.email = this.joueur.email
      if(this.dataForm.surnom === '')
        this.dataForm.surnom = this.joueur.surnom
      if(this.dataForm.type_contrat === '')
        this.dataForm.type_contrat = this.joueur.type_contrat
      if(this.dataForm.selectionne === '')
        this.dataForm.selectionne = this.joueur.selectionne
    },
    setDefaultValues() {
      const joueur = Object.assign({}, this.joueur);
      this.dataForm.nom = joueur.nom
      this.dataForm.postnom = joueur.postnom
      this.dataForm.prenom = joueur.prenom
      this.dataForm.poste = joueur.poste
      this.dataForm.taille = joueur.taille
      this.dataForm.poids = joueur.poids
      this.dataForm.date_naissance = joueur.date_naissance
      this.dataForm.dossard = joueur.dossard
      this.dataForm.photo_passeport = joueur.photo_passeport
      this.dataForm.nationalite = joueur.nationalite
      this.dataForm.equipe_id = joueur.equipe_id
      this.dataForm.date_debut_contrat = joueur.date_debut_contrat
      this.dataForm.date_fin_contrat = joueur.date_fin_contrat
      this.dataForm.commentaires = joueur.commentaires
      this.dataForm.telephones = joueur.telephones
      this.dataForm.email = joueur.email
      this.dataForm.surnom = joueur.surnom
      this.dataForm.type_contrat = joueur.type_contrat
      this.dataForm.selectionne = joueur.selectionne
    }
  },
  computed: {
    ...mapGetters([
      'getNationalites',
      'getTypesContratJoueurs',
    ])
  },
  beforeCreate() {
  },
  created() {
    this.setDefaultValues()
    //
    this.axiosGetAllData({
      table: 'equipes'
    })
        .then((data) => {
          this.equipes = data.data
        })
        .catch((data) => {
          this.equipes = data
        })
  },
  beforeMount() {
  },
  mounted() {
  },
  beforeUpdate() {
  },
  updated() {
  },
  beforeDestroy() {
  },
  destroyed() {
  }
}
</script>

<style lang="scss" scoped>
form {
  & > div {
    & > div {
      & > label, & > label {
        background-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
        color: var(--color-white, rgba(255, 255, 255, 1));
        border-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
      }

      & > label.customized-label {
        padding: 0.25rem 0.5rem;
        font-size: 0.875rem;
        line-height: 1.5;
        border-radius: 0.2rem;
      }
    }

    & > input, & > select {
      border-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/joueurs/components/Update.vue